import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { InputAdornment, TextField } from '@mui/material';
import { validDecimal } from 'app/helpers/numberHelper';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const PerCheckAmountFee = () => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const perCheckAdminFee = 'perCheckAdminFee';
  const isModEdit = useSelector(selectIsEditMod);
  const totalAdminFee: number | null | undefined = useWatch({ name: 'totalAdminFee' });

  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);

  const validation = () => {
    if (!(getValues('totalAdminFee') > 0)) {
      clearErrors('perCheckAdminFee');
    } else {
      if (!(getValues('perCheckAdminFee') > 0)) {
        setError('perCheckAdminFee', {});
      } else {
        clearErrors('perCheckAdminFee');
      }
    }
  };

  useEffect(() => {
    validation();
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={perCheckAdminFee}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.perCheckAdminFee')}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: (
              <>
                {getValues(perCheckAdminFee) && (
                  <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>
                )}
              </>
            ),
          }}
          value={getValues(perCheckAdminFee) ?? ''}
          required={!isNullOrUndefined(totalAdminFee) && !isEmpty(totalAdminFee) && totalAdminFee > 0}
          disabled={isNullOrUndefined(totalAdminFee) || isEmpty(totalAdminFee) || !(totalAdminFee > 0)}
          onChange={e => {
            if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(perCheckAdminFee, validInput, { shouldDirty: true });
              validation();
            }
          }}
        />
      )}
    />
  );
};
